import React, { Component } from "react";
import { Form } from "antd";
import FormCreate from "../../../../../components/FormCreate/index";
import SelectFrontCover from "../SelectFrontCover/index";
import styles from "./index.less";

const { Item } = Form;
const {
  FormTitle,
  FormControledCycle,
  FormCheckboxGroup,
  FormRadio
} = FormCreate;

class index extends Component {
  render() {
    const {
      form,
      cycleRemindTaskId,
      cycleRemindType,
      remindCover,
      remindTitle,
      remindTitleType,
      appId
    } = this.props;

    const { getFieldDecorator, getFieldsValue } = form;

    const formCycleProps = {
      form,
      value: cycleRemindTaskId,
      isRequired: true,
      appName: "活动打卡",
      label: "提醒设置",
      appId,
      keyName: "cycleRemindTaskId",
      itemClassName: "signCycleRemindTask",
      formProps: {
        labelCol: {
          xs: { span: 3, offset: 0 },
          sm: { span: 3, offset: 0 },
          md: { span: 3, offset: 0 },
          lg: { span: 3, offset: 0 },
          xl: { span: 3, offset: 0 }
        },
        wrapperCol: {
          xs: { span: 18, offset: 0 },
          sm: { span: 18, offset: 0 },
          md: { span: 18, offset: 0 },
          lg: { span: 18, offset: 0 },
          xl: { span: 18, offset: 0 }
        }
      },
      formItemProps: {
        label: "",
        colon: false
      }
    };

    const remindTargetProps = {
      value: cycleRemindType,
      keyName: "cycleRemindType",
      label: "提醒对象",
      tips: "说明: 已选择的提醒对象，在周期内未打卡，将接收到打卡提醒推送",
      checkboxGroupOptions: [
        {
          value: 1,
          label: "学生"
        },
        {
          value: 2,
          label: "教职工"
        }
      ],
      spanNum: 3,
      isRequired: true,
      form,
      message: "请选择提醒对象",
      tipStyle: {
        marginTop: -34
      }
    };

    // 提醒文案类别
    const remindTitleTypeProps = {
      form,
      label: "未参与提醒",
      value: remindTitleType,
      keyName: "remindTitleType",
      isRequired: true,
      className:!!getFieldsValue().remindTitleType && 'signRemindTitleType',
      RadioGroupData: [
        {
          label: "系统",
          value: 0
        },
        {
          label: "自定义",
          value: 1
        }
      ]
    };

    // 自定义提醒文案
    const remindTextProps = {
      form,
      value: remindTitle,
      label: " ",
      keyName: "remindTitle",
      isRequired: true,
      itemClassName: "selfRemindTitle",
      maxLength: 50,
      formItemProps: {
        colon: false
      },
      suffix: `${(getFieldsValue().remindTitle === undefined
        ? remindTitle && remindTitle.length
        : getFieldsValue().remindTitle &&
          getFieldsValue().remindTitle.length) || 0}/50`
    };

    // 提醒封面
    const remindCoverProps = {
      coverUrl: remindCover,
      tips: "说明：建议尺寸900*383，最大不超过5M，点击图片修改"
    };

    return (
      <div className={styles.root}>
        <div className="container">
          <FormControledCycle {...formCycleProps} />
          <FormCheckboxGroup {...remindTargetProps} />
          <FormRadio {...remindTitleTypeProps} />
          {!!getFieldsValue().remindTitleType && (
            <FormTitle {...remindTextProps} />
          )}
          <Item label="推送封面" className="pushCoverRow">
            {getFieldDecorator("remindCover", {
              initialValue: remindCover,
              valuePropName: "coverUrl",
              rules: [
                {
                  required: true
                }
              ]
            })(<SelectFrontCover {...remindCoverProps} />)}
          </Item>
        </div>
      </div>
    );
  }
}

export default index;
